/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Utbildning - CamAPS FX',
    titleMeta: 'Vi tillhandahåller kostnadsfri webbaserad utbildning för CamAPS FX-användare.',
    descriptionMeta: 'Cambridge Diabetes Education Programme håller kostnadsfria webbaserade utbildningar för personer med diabetes typ 1, föräldrar och vårdnadshavare, skolpersonal och hälso- och sjukvårdspersonal.',
    keywords: 'camps träning, camps fx träning, ',
    localeMeta: 'sv_se',
    mainHeader: 'Vårdutbildning',
    mainSubHeader: 'Stöd personer som använder CamAPS FX med expertledd utbildning.',
    gettingStartedHeader: 'Komma igång',
    step1Title: '<strong>Steg 1:</strong><br/>Ladda ner appen',
    step2Title: '<strong>Steg 2:</strong><br/>Skapa ett konto',
    step3Title: '<strong>Steg 3:</strong><br/>Påbörja den grundläggande utbildningen i appen',
    step4Title: '<strong>Steg 4:</strong><br/>Para ihop med din valda pump och CGM (med godkännande från ditt vårdteam) eller utforska appen med <strong>virtuellt läge</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Utbildning med legitimerad utbildare',
    trainingHeader: 'Utbildning med legitimerad utbildare',
    trainingHeader_2: 'För hälso- och sjukvårdspersonal',
    trainingHeader_3: 'Användarutbildning',
    trainingHeaderText: 'KOSTNADSFRI webbaserad utbildning i CamAPS FX tillhandahålls av Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-utbildning',
    getTrained: 'Gå utbildningen',
    trainingHeaderIat: 'CamAPS FX-träning',
    trainingHeaderTextIat: 'Genomför den grundläggande utbildningen i appen innan du använder CamAPS FX-appen.',
    trainingSubHeaderOneIat: 'Kom igång',
    trainingSubTextOneIat: 'Ladda ner CamAPS FX-appen. <br>Skapa ett konto för att påbörja träningen.',
    trainingSubHeaderTwoIat: 'Behöver du hjälp med att installera appen?',
    trainingParaTwoStartIat: 'Besök vår',
    trainingParaTwoEndIat: 'sektion för vägledning.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Ytterligare resurser',
    animationsYpsoPumpText: 'Animationer',
    animationsAndText: 'och',
    animationsDanaText: 'Animationer (Dana-pump)',
    animationsFurtherText: 'Lär dig genom steg-för-steg visuella guider.',
    webinarsText: 'Webbinarier',
    webinarsFurtherText: 'Titta på expertledda sessioner om hur du använder appen.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
